import { mutationTypes, actionTypes } from '../access-keys'
import defaultStates from './unsubscribe/default-states'
import { map } from '../helpers/mapper'

export default {
  namespaced: true,
  state: defaultStates.forRoot(),
  getters: {},
  mutations: {
    [mutationTypes.unsubscribe.RESET_STATE](state) {
      map(defaultStates.forRoot(), state)
    },
    [mutationTypes.unsubscribe.ACTIVATE_STEP](state, step) {
      if (step > state.stepActiveTo) {
        state.stepActiveTo = step
      }
    },
    [mutationTypes.unsubscribe.UNACTIVATE_STEP](state, step) {
      if (step < state.stepActiveTo) {
        state.stepActiveTo = step
      }
    }
  },
  actions: {
    [actionTypes.unsubscribe.RESET_FORM]({ commit }) {
      commit(mutationTypes.unsubscribe.RESET_STATE)
      commit(mutationTypes.unsubscribe.step1.RESET_STATE_ROOT, null, { root: true })
      commit(mutationTypes.unsubscribe.step2.RESET_STATE_ROOT, null, { root: true })
    }
  },
  modules: {
    step1: {
      namespaced: true,
      state: defaultStates.forStep1(),
      getters: {},
      mutations: {
        [mutationTypes.unsubscribe.step1.RESET_STATE](state) {
          map(defaultStates.forStep1(), state)
        },
        [mutationTypes.unsubscribe.step1.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.unsubscribe.step1.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.unsubscribe.step1.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.unsubscribe.ACTIVATE_STEP_ROOT, 2, { root: true })
        }
      }
    },
    step2: {
      namespaced: true,
      state: defaultStates.forStep2(),
      getters: {},
      mutations: {
        [mutationTypes.unsubscribe.step2.RESET_STATE](state) {
          map(defaultStates.forStep2(), state)
        },
        [mutationTypes.unsubscribe.step2.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.unsubscribe.step2.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.unsubscribe.step2.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.unsubscribe.ACTIVATE_STEP_ROOT, 3, { root: true })
        }
      }
    }
  }
}
